import { Box, SxProps } from '@mui/material';

import { assetUrl } from '../../../../helpers/assetUrl';
import { DEFAULT_LOGO_CONF } from './helpers';

const getStyles = (): { [key: string]: SxProps } => {
  return {
    imageLink: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '64px',
    },
    withShadow: {
      filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.15))',
    },
  };
};

export interface LogoConfig {
  fileName: string;
  width: number;
  label: string;
}

interface ToolbarLogoProps {
  textLogoFileConfig?: LogoConfig;
}

export default function ToolbarLogo(props: ToolbarLogoProps) {
  const { textLogoFileConfig = DEFAULT_LOGO_CONF } = props;
  const homePageLink = window.location.origin;

  const styles = getStyles();

  return (
    <>
      <Box display={{ xs: 'none', sm: 'none', lg: 'block' }}>
        <Box component="a" href={homePageLink} sx={styles.imageLink}>
          <img
            src={assetUrl(`/images/logos/${textLogoFileConfig.fileName}`)}
            alt={textLogoFileConfig.label}
            width={textLogoFileConfig.width}
          />
        </Box>
      </Box>

      <Box display={{ xs: 'none', sm: 'block', md: 'block', lg: 'none' }}>
        <Box component="a" href={homePageLink} sx={styles.imageLink}>
          <img
            src={assetUrl(`/images/logos/${DEFAULT_LOGO_CONF.fileName}`)}
            alt={DEFAULT_LOGO_CONF.label}
            width={DEFAULT_LOGO_CONF.width}
          />
        </Box>
      </Box>

      <Box display={{ xs: 'block', sm: 'none' }}>
        <Box component="a" href={homePageLink} sx={styles.imageLink}>
          <Box
            component="img"
            sx={styles.withShadow}
            src={assetUrl('/images/logos/logo-app.svg')}
            alt="Tertius"
            height="32"
          />
        </Box>
      </Box>
    </>
  );
}
